import React from 'react';

import SortableTable, {SortableTableColumn} from 'ui-library/SortableTable';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

const {defaultColumn} = SortableTable;

interface OpenReview {
  entryName: string;
  status: string;
  role: 'Auditor' | 'Author';
}

interface UserOpenReviewsProps {
  openReviews: Array<OpenReview>;
}

function UserOpenReviews({openReviews}: UserOpenReviewsProps): JSX.Element {
  const columns: Array<SortableTableColumn> = [
    defaultColumn('Entry Name', 'entryName'),
    defaultColumn('Status', 'status', {
      transform: (value: string): string => capitalize(constantCaseToWords(value)),
    }),
    defaultColumn('Role', 'role'),
  ];
  return (
    <div>
      <h4>{`Open Reviews (${openReviews.length})`}</h4>
      <SortableTable columns={columns} rows={openReviews} />
    </div>
  );
}

export default UserOpenReviews;
